import { BCMSRecord, Workflow, useBCMSContext } from "@bcm-dev/bcms-vite";
import AddEmailContactView from "components/custom-ui/CustomModal/components/AddContactMethodModal/components/AddEmailContactView";
import EnterActivationCodeView from "components/custom-ui/CustomModal/components/AddContactMethodModal/components/EnterActivationCodeView";
import Classes, { ContactInfo } from "model";
//import EnterActivationCodeAddEmailView from "components/custom-ui/CustomModal/components/AddContactMethodModal/components/EnterActivationCodeAddEmailView";
// Steps of the workflow
var steps = [
    AddEmailContactView,
    EnterActivationCodeView
];

/**
 * @function AddEmailContactMethodModalWorkflow
 * 
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the add email contact info modal workflow.
 */
export default function AddEmailContactMethodModalWorkflow(props) {
    // Get the inital state of the workflow
    const controller = useBCMSContext();
    const { workflowType, refresh, values, step } = props;

    BCMSRecord.globalControllerFor(Classes, controller);

    const defaults = { ...getDefaultAddEmail(workflowType, refresh), ...values ?? {} };
    return <Workflow value={ defaults } steps={ steps } step={ step ?? 0 } />
}
// Return the steps of the workflow
export const getWorkflowStepsAddEmail = () => steps;

/**
 * @function getDefault
 * 
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefaultAddEmail = (type, refresh) => {
    return {
        data: {
            info: ContactInfo.init({
                id: ContactInfo.nextID(),
                isPrimary: "false",
                isConfirmed: "false",
                value: ""
            }),

            unconfirmedContacts: []
        },
        ui: {
            workflowType: type,
            refresh
        }
    }
};